var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('my-head'),_c('div',{staticClass:"transferregistration minH"},[_c('div',{staticClass:"title"},[_vm._v("发布项目（意向挂牌）")]),_c('Transfer-information',{attrs:{"cid":_vm.id,"proj-type":1}})],1),_c('my-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }